import React from 'react';
import { MaterialIcon } from '../ui/MaterialIcon';

interface IconButtonProps {
  icon: string;
  onClick?: () => void;
  badge?: React.ReactNode;
  tone?: 'default' | 'filled';
  size?: number;
  className?: string;
}

// Calca ObrosIconBtn de mobile-frame.jsx: botón circular 44x44 con badge opcional.
export const IconButton: React.FC<IconButtonProps> = ({ icon, onClick, badge, tone = 'default', size = 44, className = '' }) => (
  <button
    onClick={onClick}
    style={{ width: size, height: size }}
    className={`relative shrink-0 rounded-full flex items-center justify-center transition-colors ${
      tone === 'filled' ? 'bg-primary-500 text-white' : 'text-onSurface hover:bg-black/5'
    } ${className}`}
  >
    <MaterialIcon name={icon} size={24} />
    {badge != null && (
      <span className="absolute top-1.5 right-1.5 min-w-[16px] h-4 px-1 rounded-full bg-danger-600 text-white text-[10px] font-bold flex items-center justify-center leading-none">
        {badge}
      </span>
    )}
  </button>
);
